import { FeberApiClient } from "../../services/commonServices";
import { removeAliasDomain } from "../../utils/converter";

export const getMySubscriptions = async (yourUserId: string) => {
    let response = await (await FeberApiClient.get("Subscription/MySubscriptions", { params: { yourUserId: removeAliasDomain(yourUserId) } })).data;
    return !!response.data ? response.data : []
}

export const addSubscription = async (userId: string, title: string) => {
    let response = await (await FeberApiClient.post("Subscription", {
        peopleId: removeAliasDomain(userId),
        title: title
    })).data
    return response;
}

export const updateSubscription = async (id: number, title: string) => {
    let response = await (await FeberApiClient.put("Subscription", { id: id, title: title })).data
    return response.success;
}

export const removeSubscription = async (subscriptionId: number) => {
    let response = await FeberApiClient.delete("Subscription", { params: { id: subscriptionId } });
    return await response.data.success;
}